export default __webpack_public_path__ + "static/tim-bb4229d2dee090682434b496abac75d8.jpg";